export default {
      id: "facebook-usage",
      viewBox: "0 0 20 21",
      url: "../../assets/" + "sprite.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }